var _desc, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuctionBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(27.7483 0 0 27.7483 499.9994 499.9995)",
    id: 606221
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-18.3809, -17.7284)",
    d: "M 18.959 2.5 a 1.213 1.213 0 0 0 -0.789 0.362 A 1.094 1.094 0 0 0 18.09 4.4 l 0.085 0.087 A 1.149 1.149 0 0 1 16.55 6.117 l 0 -0.011 l -6.5 6.5 l 0.014 0.014 A 1.149 1.149 0 0 1 8.423 14.24 l -0.087 -0.085 a 1.094 1.094 0 0 0 -1.545 0.08 a 1.094 1.094 0 0 0 -0.08 1.545 l 5.852 5.851 a 1.156 1.156 0 0 0 1.625 -1.625 l -0.08 -0.08 A 1.149 1.149 0 1 1 15.733 18.3 l 1.625 -1.626 l 1.218 1.22 a 1.715 1.715 0 0 0 1.959 0.333 L 31.174 28.865 A 1.15 1.15 0 0 0 32.8 30.49 l 1.625 -1.625 A 1.149 1.149 0 1 0 32.8 27.239 L 22.172 16.586 l -0.009 0.011 a 1.715 1.715 0 0 0 -0.334 -1.953 L 20.61 13.426 L 22.234 11.8 a 1.152 1.152 0 0 1 0.514 -1.923 a 1.137 1.137 0 0 1 1.1 0.29 l 0.09 0.09 a 1.155 1.155 0 0 0 1.624 -1.625 L 19.714 2.778 a 0.985 0.985 0 0 0 -0.755 -0.28 Z M 3.724 28.363 a 0.561 0.561 0 0 0 -0.575 0.575 v 1.724 A 1.135 1.135 0 0 0 2 31.812 v 1.149 H 14.644 V 31.812 a 1.135 1.135 0 0 0 -1.149 -1.149 V 28.938 a 0.562 0.562 0 0 0 -0.575 -0.575 Z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuctionBlack);
export default __webpack_public_path__ + "static/media/AuctionBlack.531db512fcf6f57af49cb8ad5580299f.svg";
export { ForwardRef as ReactComponent };